export default "__VITE_ASSET__CaTpizCu__"